import axios from "axios";
import * as types from '../constants/ActionTypes';
import { toast } from 'react-toastify';

// Url's
// const userInfoUrl = `${process.env.REACT_APP_API_URL}mobileshop/consumer-authenticate`;
// const webSessionUrl = `${process.env.REACT_APP_API_URL}api/csa-app/get-web-session-trans-id`;
// const updateUserInfoUrl = `${process.env.REACT_APP_API_URL}api/csa-app/get-consumer-detail`;

const userInfoUrl = `${process.env.REACT_APP_API_URL}mobileshop/consumer-authenticate`;
const webSessionUrl = `${process.env.REACT_APP_API_URL}mobileshop/csacart/get-web-session-trans-id`;
const logoutUrl = `${process.env.REACT_APP_API_URL}mobileshop/logout`;
const updateUserInfoUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaprofile/get-consumer-detail`;

// Actions
const userInfoSuccess = data => ({
  type: types.USERINFO_SUCCESS,
  data
});

const userInfoUpdate = data => ({
  type: types.USERINFO_UPDATE,
  data
});

const userInfoRequested = () => ({
  type: types.USERINFO_REQUEST
});

// const logoutSuccess = data => ({
//   type: types.LOGOUT_SUCCESS,
//   data
// });

// const logoutFailure = data => ({
//   type: types.LOGOUT_FAILURE,
//   data
// });

// const logoutRequested = () => ({
//   type: types.LOGOUT_REQUEST
// });

const userInfoFailure = error => ({
  type: types.USERINFO_FAILURE,
  error
});

const userInfoDelete = () => ({
  type: types.USERINFO_DELETE
});

const webSessionUpdate = data => ({
  type: types.WEBSESSION_UPDATE,
  data
});

const orderListDelete = () => ({
  type: types.ORDERLIST_DELETE
});

const csaUserAuth = () => ({
  type: types.CSA_USER_AUTH,
})

const clearUserInfo = () => ({
  type:types.CLEAR_USER_INFO
})



// API
export const getUserInfo = (user) => {
  return dispatch => {
    dispatch(userInfoRequested());
    axios.post(userInfoUrl, user, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        //'Content-Type': 'application/json; charset=UTF-8'
      }
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(userInfoSuccess(res.data.results));
        } else if (res.data.ack === "Failure") {
          toast.error(`${res.data.status.message ? res.data.status.message : 'Login failed. Mobile Number or Password might be incorrect. Try again.'}`);
          dispatch(userInfoFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};

export const updateUserInfo = (user) => {
  return async dispatch => {
    try {
    dispatch(userInfoRequested());    
   const response = await axios.get(updateUserInfoUrl, {
      params: {
        connection_id: user.connection_id,
        mobile_no: user.mobile_no,
        tenant_name : user.tenant_name
      }      
    }).then(res => res.data);
        if (response.ack === "Success") {
          localStorage.setItem('mobile_no',user.mobile_no)
          localStorage.removeItem('newRegNumber')
          dispatch(userInfoUpdate(response.results));
        } else if (response.ack === "Failure") {
          localStorage.setItem('newRegNumber',user.mobile_no)
          localStorage.setItem('mobile_no',user.mobile_no)
         // toast.error(response.status.message)
          dispatch(userInfoFailure(response.status));
          
        }
    }
      catch(err)  {
        throw err;
        // dispatch(addTodoFailure(err.message));
      };
  };
};


export const getWebSessionId = (connection_id) => {
  return async (dispatch) => {
    dispatch(userInfoRequested());

    try {
      const res = await axios.get(webSessionUrl, {
        params: { connection_id },
      });

      if (res.data.ack === "Success") {
        dispatch(webSessionUpdate(res.data.results));
      } else if (res.data.ack === "Failure") {
        toast.error(`Failed - ${res.data.status.message}`);
        dispatch(userInfoFailure(res.data.status));
      }
    } catch (err) {
      console.error(err);
      dispatch(userInfoFailure(err.message));
    }
  };
};


 export const logout = () => {
   return dispatch => {
     localStorage.removeItem('csa_user_id');
     localStorage.removeItem('csa_password');
     dispatch(userInfoDelete());
     dispatch(orderListDelete());
   };

 };
// export const logout=(connection_id)=>{
//  return dispatch => {
//     dispatch(logoutRequested());
//     axios.get(logoutUrl, {
//       params: {
//         connection_id
//       },
//     })
//       .then(res => {
//         if (res.data.ack === "Success") {
//            localStorage.removeItem('csa_user_id');
//      localStorage.removeItem('csa_password');
//      dispatch(userInfoDelete());
//      dispatch(orderListDelete());
//           dispatch(logoutSuccess(res.data.results));
//         } else if (res.data.ack === "Failure") {
//           toast.error(`Failed - ${res.data.status.message}`);
//           dispatch(logoutFailure(res.data.status));
//         }
//       })
//       .catch(err => {
//         throw err;
//         // dispatch(addTodoFailure(err.message));
//       });
//   };
// }

export const getCsaUserAuth = () => {
  return dispatch => {
    dispatch(csaUserAuth());
  }
}

export const clearUserDetails = () => {
  return dispatch => {
    dispatch(clearUserInfo());
  }
}

